import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

function Signout() {
  const [isloggedin, setIsLoggedIn] = useState(false);

  const navigate = useNavigate();

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  axios.defaults.withCredentials = true;
  axios.post(BACKEND_URL + '/signout')
  .then(res => {
    setIsLoggedIn(res.data.isloggedin); 
  })
  .catch(err => { navigate('/signin'); })

  return isloggedin;
}

export default Signout;